import dayjs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import utc from 'dayjs/plugin/utc';
import minMax from 'dayjs/plugin/minMax';

dayjs.extend(customParseFormat);
dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);
dayjs.extend(utc);
dayjs.extend(minMax);

export function useDate() {
  const formatToDate = (datetime) => dayjs.utc(datetime).format('DD/MM/YYYY');
  const timeAgo = (datetime) => dayjs.utc(datetime).fromNow();
  const getMaxDate = (dateList) => dayjs.max(dateList);

  return {
    date: dayjs,
    formatToDate,
    timeAgo,
    getMaxDate
  }
}
